import * as React from 'react'
import { connect } from 'react-redux'
import * as st from '../../components/utilityClasses.module.scss'
import { Container } from '@amzn/dvui/dist/Container'
import { BtfProductMetaInfo } from '../../components/productMetaInfo/btfProductMetaInfo'
import { IDetailPageState } from '../../reducers'
import { Faq } from '../../components/faq/faq'
import { ContactUs } from '../../components/contactUs/contactUs'
import { Carousel } from '../../components/carousel/carousel'
import { ScoutBanner } from '../../components/scoutBanner/scoutBanner'
import { CastAndCrew } from '../../components/castAndCrew/castAndCrew'
import { blockedPageSelector } from '../../selectors/component/pageBlockComponentSelectors'
import { OtherFormats } from '../../components/otherFormats/otherFormats'

type Props = ReturnType<typeof mapStateToProps>

const ConnectedAdditional = ({
  faq,
  contactUs,
  useFaq,
  useContactUs,
  otherFormats,
  castAndCrew,
  scout,
  pageBlock
}: Props) => {
  // Page block prevents any render in btf-additional. Message will be shown in atf
  if (pageBlock) {
    return null
  }

  return (
    <>
      <Carousel />
      {!global.__NATIVEAPP__ && <ScoutBanner content={scout} />}
      <CastAndCrew content={castAndCrew} />
      <Container className={st.pageSection}>
        <BtfProductMetaInfo />
      </Container>
      {useFaq && <Faq content={faq} />}
      {useContactUs && <ContactUs content={contactUs} />}
      <Container className={st.pageSection}>
        <OtherFormats content={otherFormats} />
      </Container>
    </>
  )
}

const mapStateToProps = (state: IDetailPageState) => ({
  useFaq: Boolean(state.features.useFaq),
  useContactUs: Boolean(state.features.useContactUs),
  faq: state.faq[state.pageTitleId],
  contactUs: state.contactUs[state.pageTitleId],
  otherFormats: state.otherFormats[state.pageTitleId],
  castAndCrew: state.castAndCrew[state.pageTitleId],
  scout: state.scoutBanner[state.pageTitleId],
  pageBlock: blockedPageSelector(state),
})

export const AdditionalComponent = connect(mapStateToProps)(ConnectedAdditional)
